
import { defineComponent } from 'vue';
import { Route, NavigationGuardNext } from 'vue-router';
import store from '@/store';
import HeaderPrincipal from '@/componentes/UI/HeaderPrincipal.vue';
import ProgresoPasos from '@/componentes/ProgresoPasos.vue';
import ReceiptRow from "@/componentes/pago/ReceiptRow.vue"; // Import the separate component
import { getEstadoPagoMatricula, getEstadoPagoArancel, ComprobanteI } from '@/assets/api/pagos';

interface EstadoPagoResponse {
  mensaje: string;
  estado: string;
  comprobante_pago: ComprobanteI | null;
}

export default defineComponent({
  name: 'EstadoPagoWebpay',
  components: {
    HeaderPrincipal,
    ProgresoPasos,
    ReceiptRow, // Register the imported component
  },
  data() {
    return {
      mensaje: '' as string,
      comprobante: null as ComprobanteI | null,
      aprobado: false as boolean,
      tipoPago: {
        VD: 'Venta Débito',
        VN: 'Venta Normal',
        VC: 'Venta en cuotas',
        SI: '3 cuotas sin interés',
        S2: '2 cuotas sin interés',
        NC: 'N Cuotas sin interés',
        VP: 'Venta Prepago',
      } as Record<string, string>
    };
  },
  computed: {
    producto(): string {
      return this.$route.name === 'estado pago matricula' ? 'matrícula' : 'arancel';
    },
    siguienteRuta(): string {
      if (this.$route.name === 'estado pago matricula' && this.$store.getters.etapaEstudiante === 3) {
        return store.getters.linkPagoArancel;
      }
      return 'resumen';
    },
    anteriorRuta(): string {
      return this.$route.name === 'estado pago matricula'
        ? store.getters.linkPagoMatricula
        : store.getters.linkPagoArancel;
    },
    pasoActual(): number {
      return this.$route.name === 'estado pago matricula' ? 3 : 4;
    }
  },
  methods: {
    formatCurrency(amount: number | string): string {
      const num = typeof amount === 'string' ? parseFloat(amount) : amount;
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(num);
    },
    formatDate(dateString: string): string {
      try {
        const date = new Date(dateString);
        return date.toLocaleString('es-CL', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        });
      } catch (error) {
        console.error('Error formatting date:', error);
        return dateString;
      }
    }
  },
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    // Route guards with proper validation
    const etapaEstudiante = store.getters.etapaEstudiante;

    // Redirect based on current stage
    if (etapaEstudiante === 0) {
      next({ name: store.getters.linkBienvenida });
      return;
    }
    if (etapaEstudiante === 1) {
      next({
        name: store.getters.esPostulanteEduCont
          ? 'perfil estudiante educontinua'
          : 'perfil estudiante'
      });
      return;
    }

    // Determine which payment status to check
    const promesaEstadoPago = to.name === 'estado pago matricula'
      ? getEstadoPagoMatricula(store.getters.idEstudiante)
      : getEstadoPagoArancel(store.getters.idEstudiante);

    promesaEstadoPago
      .then((estadoPago: EstadoPagoResponse) => {
        next((vm: any) => {
          vm.mensaje = estadoPago.mensaje;
          vm.aprobado = estadoPago.estado === 'OK';
          vm.comprobante = estadoPago.comprobante_pago;
        });
      })
      .catch((error) => {
        console.error('Error fetching payment status:', error);
        next({ name: store.getters.linkInicio });
      });
  }
});
